import { Button } from 'components/Button'
import { DataTable, DataTableMessageRow } from 'components/DataTable'
import { TagChip } from 'components/TagChip'
import { DATE_FORMAT } from 'constants/index'
import { commonStrings, tagManagementStrings } from 'constants/strings'
import type { TTag } from 'types'
import formatDate from 'utils/formatDate'

type TagsTableProps = {
  tags: TTag[]
  loading: boolean
  emptyMessage?: string
  onEdit: (tagId: number) => void
  onDelete: (tag: TTag) => void
}

export function TagsTable({
  tags,
  loading,
  emptyMessage = tagManagementStrings.states.empty,
  onEdit,
  onDelete,
}: TagsTableProps) {
  let body: JSX.Element | JSX.Element[]

  if (loading) {
    body = <DataTableMessageRow colSpan={4} message={commonStrings.loading} />
  } else if (tags.length === 0) {
    body = <DataTableMessageRow colSpan={4} message={emptyMessage} />
  } else {
    body = tags.map((tag) => (
      <tr key={tag.id} className="border-t border-border/60 bg-white">
        <td className="px-2 py-3 text-left">
          <div className="flex gap-2">
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => onEdit(tag.id)}
            >
              {commonStrings.actions.edit}
            </Button>
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="text-danger"
              onClick={() => onDelete(tag)}
            >
              {commonStrings.actions.delete}
            </Button>
          </div>
        </td>
        <td className="px-2 py-3">
          <TagChip name={tag.name} color={tag.color} />
        </td>
        <td className="px-2 py-3 text-[11px] text-ink sm:text-sm">
          {tag.friendCount}
        </td>
        <td className="px-2 py-3 text-[11px] text-ink sm:text-sm">
          {formatDate(tag.createdAt, DATE_FORMAT)}
        </td>
      </tr>
    ))
  }

  return (
    <DataTable
      minWidthClassName="min-w-[560px]"
      tableLayout="auto"
      headerRow={
        <tr>
          <th className="px-2 py-3 text-left leading-tight break-words">
            {tagManagementStrings.table.headers.actions}
          </th>
          <th className="px-2 py-3 text-left leading-tight break-words">
            {tagManagementStrings.table.headers.tag}
          </th>
          <th className="px-2 py-3 text-left leading-tight break-words">
            {tagManagementStrings.table.headers.friendCount}
          </th>
          <th className="px-2 py-3 text-left leading-tight break-words">
            {tagManagementStrings.table.headers.createdAt}
          </th>
        </tr>
      }
    >
      {body}
    </DataTable>
  )
}
